import type { VendorMetadataExtractor } from './types'
import { extractEmbeddedGps } from './embedded-gps'

export const nextbaseExtractor: VendorMetadataExtractor = {
  vendorId: 'nextbase',
  vendorLabel: 'Nextbase',
  supportsDirectoryBrowse: false,

  // Nextbase's proprietary boxes and .NBD sidecars are not parsed (out of scope); only generic embedded GPS is read.
  extractFromFiles: extractEmbeddedGps
}
